import e, { css as s } from "styled-components";
import { Y_POSITION as i } from "../../../constants/position.es.js";
const g = e.div.withConfig({
  displayName: "ProgressHeader",
  componentId: "sc-1pgh7bs-0"
})(["align-items:center;display:flex;font-weight:700;justify-content:space-between;", ""], ({
  infoPosition: r
}) => r === i.bottom && s(["order:2;"])), c = e.div.withConfig({
  displayName: "ProgressText",
  componentId: "sc-1pgh7bs-1"
})([""]), n = e.div.withConfig({
  displayName: "ProgressRate",
  componentId: "sc-1pgh7bs-2"
})(["margin-left:auto;"]), t = e.progress.withConfig({
  displayName: "ProgressBar",
  componentId: "sc-1pgh7bs-3"
})(["appearance:none;width:100%;"]), a = {
  sm: {
    height: "0.4rem",
    gap: "0.4rem",
    fontSize: "1rem"
  },
  md: {
    height: "0.6rem",
    gap: "0.6rem",
    fontSize: "1.2rem"
  },
  lg: {
    height: "0.8rem",
    gap: "0.8rem",
    fontSize: "1.4rem"
  }
}, p = e.div.withConfig({
  displayName: "Progress",
  componentId: "sc-1pgh7bs-4"
})(["", ""], ({
  size: r,
  status: o
}) => s(["display:flex;flex-direction:column;font-size:", ";gap:", ";", "{color:var(--color-fg-default);}", "{height:", ";::-webkit-progress-bar{background-color:var(--color-accent-primary-weaker);border-radius:var(--size-border-radius-pill);}::-webkit-progress-value{background-color:var(--color-accent-primary-default);border-radius:var(--size-border-radius-pill);}::-moz-progress-bar{background-color:var(--color-accent-primary-default);}::-ms-fill{background-color:var(--color-accent-primary-default);}", "}"], a[r].fontSize, a[r].gap, c, t, a[r].height, o && s(["::-webkit-progress-bar{background-color:var(--color-", "-weaker);border-radius:var(--size-border-radius-pill);}::-webkit-progress-value{background-color:var(--color-", "-default);}::-moz-progress-bar{background-color:var(--color-", "-default);}::-ms-fill{background-color:var(--color-", "-default);}"], o, o, o, o)));
export {
  p as Progress,
  t as ProgressBar,
  g as ProgressHeader,
  n as ProgressRate,
  c as ProgressText
};
//# sourceMappingURL=style.es.js.map
